<template>
  <div class="container-fluid" v-if="$vlastMode">
    <div v-if="!optedIn">
      <campaign-notification
        theme="light"
        icon="heart"
        title="Looking for a meaningful way to connect with clients?"
        heading="1000 virtual meetings in 100 days"
        summary="Jump on our mission to connect sports stars into 1000 virtual meetings in 100 days! We are calling on all our stars to donate your time and be available to join virtual team meetings for just 15 minutes. You more than anyone are equipped with the profile and mindset skills to bring joy and inspiration at a time when people need it the most.">
        <template v-slot:buttons>
            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleOptInCallback">
              I'm Keen
            </ladda-button>
        </template>
      </campaign-notification>
    </div>
    <div v-else-if="optedIn">
      <campaign-notification
        theme="light"
        icon="check-circle"
        title="Thank you!"
        summary="We are currently fielding lots of enquiries from a whole range of businesses. We will be in contact with opportunities throughout the next 100 days."
        :has-buttons="false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CampaignNotification from '../campaign/CampaignNotification'

export default {
  components: {
    CampaignNotification
  },
  created () {
    this.checkPackageOptInStatus({ talentId: this.$user.id, packageId: 2 })
  },

  methods: {
    ...mapActions('talent/packages', ['packageOptIn', 'checkPackageOptInStatus']),

    handleOptInCallback () {
      this.packageOptIn({ talentId: this.$user.id, packageId: 2 })
    }
  },

  computed: {
    ...mapState('talent/packages', ['optedIn'])
  }
}
</script>
